import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink, Link} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import Icon from '@material-ui/core/Icon';
import Assignment from "@material-ui/icons/Assignment";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import LocalHospital from "@material-ui/icons/LocalHospital";
import Button from "components/CustomButtons/Button.jsx";


import GridContainer from "components/Grid/GridContainer.jsx";

import {mappingUI, dashboardRouter, getDateConverter, titleCase} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
class OneReport extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            selectPic: 0,
            deleted: false
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.sendSMSApi = this.sendSMSApi.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    sendSMSApi() {
        var postBody = {
            "contact": this.state.data !== null ? this.state.data.patient_id.user_id.contact : null,
            "message": "Hi " + (this.state.data !== null && this.state.data.patient_id.user_id && this.state.data.patient_id.user_id.name ? titleCase(this.state.data.patient_id.user_id.name) : "") + ", your report is available on Healthspace. You can access it using this link : " + window.location.origin + "/patient/report/view/" + this.props.id.match.params.id
        };
        api.sendCustomMessage(postBody).then(json => {
            this.setState({status: "", comments: "", alert: null})
        });
    }


    CallReadApi = (id) => {
        api.getReportList({_id: id})
            .then(json => {
                this.setState({data: json.data.data[0]});
                if (json.data.isError === false && json.data.data.length === 0) {
                    this.setState({notFound: {"deleted": "yes"}})
                }
            }).catch(error => {
            this.setState({notFound: error})
        });
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data !== null && this.state.data !== [] && this.state.data !== undefined) {
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Assignment/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Report</h4>

                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={10} md={6}>
                                            <GridContainer>
                                                {/* Report Header */}
                                                <GridItem xs={12}>
                                                    <h3>{data.title ? data.title : "No Title"}</h3>
                                                </GridItem>
                                                <GridItem xs={12}>
                                                    <p><b>{data.description ? data.description : null}</b></p>
                                                </GridItem>
                                                {/*<GridItem xs={12}>
                                                 <p><b>{data.created_at ? getDateConverter(data.created_at) : null}</b></p>
                                                 </GridItem>*/}
                                            </GridContainer>
                                            <GridContainer>
                                                {/* Patient Info */}
                                                <GridItem xs={12}>
                                                    <h4>
                                                        <NavLink
                                                            to={dashboardRouter(`/patient/${data.patient_id._id}`)}>
                                                            <b><a>{data && data.patient_id ? data.patient_id.user_id.name : null}</a></b>
                                                        </NavLink>
                                                    </h4>
                                                </GridItem>
                                                <GridItem xs={12}>
                                                    <b>{data && data.patient_id ? data.patient_id.user_id.contact : null}</b>
                                                </GridItem>
                                                <GridItem xs={12}>
                                                    <b>{data && data.patient_id ? data.patient_id.user_id.email : null}</b>
                                                </GridItem>
                                                <GridItem xs={12}>
                                                    <b>{data && data.patient_id ? data.patient_id.user_id.gender : null}</b>
                                                </GridItem>

                                            </GridContainer>

                                            <GridItem>
                                                {/* Doctor Info */}
                                                <br/>
                                                <br/>
                                                <GridItem>
                                                    <h3>{data && data.doctor_id ? "Dr. " + data.doctor_id.user_id.name : null}</h3>

                                                </GridItem>
                                            </GridItem>

                                        </GridItem>
                                        <GridItem md={4} xs={12} className="centerDiv">

                                            <GridItem>
                                                <br /><br />
                                                <h4><b>{data.created_at ? getDateConverter(data.created_at) : null}</b>
                                                </h4>

                                                <NavLink
                                                    to={dashboardRouter(`/report/update/${data._id}`)}>
                                                    <Button block size="md" color="warning">
                                                        <Icon>border_color</Icon>
                                                        <span style={{paddingLeft: 10}}>Update</span>
                                                    </Button>
                                                </NavLink>
                                                <br />
                                                <Button block size="md" color="success"
                                                        onClick={() => this.sendSMSApi()}>
                                                    <span style={{paddingLeft: 10}}>Send SMS</span>
                                                </Button><br/>
                                                <a target="_blank"
                                                   href={`https://web.whatsapp.com/send?text=${"Hi " + (this.state.data !== null && this.state.data.patient_id.user_id && this.state.data.patient_id.user_id.name ? titleCase(this.state.data.patient_id.user_id.name) : "") + ", your report is available on Healthspace. You can access it using this link : " + window.location.origin + "/patient/report/view/" + this.props.id.match.params.id}`}>
                                                    <Button
                                                        block size="md" color="success">
                                                        <span style={{paddingLeft: 10}}>Send Whatsapp</span>
                                                    </Button></a><br/>
                                                {/*<NavLink*/}
                                                {/*to={dashboardRouter(`/print/report/${data._id}`)}>*/}
                                                {/*<Button block size="md" color="info">*/}
                                                {/*<span style={{paddingLeft: 10}}>Print</span>*/}
                                                {/*</Button>*/}
                                                {/*</NavLink>*/}
                                                {/*<Button color="danger"*/}
                                                {/*onClick={this.DeleteAlert('Delete', data1.doctor_id)}*/}
                                                {/*>*/}
                                                {/*<Icon>delete</Icon>Delete</Button>*/}
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer justify="center" className="centerDiv">
                                        {data.report_link.map((item, index) => {
                                            return <div onClick={() => this.setState({selectPic: index})}
                                                        key={Math.random()} style={this.state.selectPic === index ? {
                                                padding: '10px',
                                                margin: '10px',
                                                border: '1px solid',
                                                background: '#39abc1',
                                                color: 'white'
                                            } : {
                                                padding: '10px',
                                                margin: '10px',
                                                border: '1px solid',
                                                background: '#fff',
                                                color: 'black'
                                            }}>{item.type !== "" ? `${item.type} ${index + 1}` : `Others ${index + 1}`}</div>
                                        })}
                                    </GridContainer> <br/> <br/> <br/>
                                    <GridContainer className="centerDiv">
                                        {data.report_link.length > 0 ? showReport(data.report_link[this.state.selectPic].link) : null}
                                        <br /><br /><br />
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        }
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (
                <div>
                    <Loader/>
                </div>
            )
    }
}
export default withStyles(styles)(OneReport);


function showReport(url) {
    var type = url.substr(-3).toLowerCase();
    switch (type) {
        case ("pdf"):
            return <object data={url}
                           type="application/pdf"
                           width="800" height="1200">
                <div className="centerDiv"
                     style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                    href={url}><Button block
                                       size="lg"
                                       color="success">
                    Open Report
                </Button></a></div>
            </object>;
        case ("doc"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("docx"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("rtf"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case ("dot"):
            return <iframe src={`https://docs.google.com/gview?url=${url}&embedded=true`} width="800"
                           height="1200"/>
        case("jpeg"):
            return <a href={url} download>
                {/*<div id="navbar">*/}
                {/*<button type="button" onClick={() => zoomin()}> Zoom In</button>*/}
                {/*<button type="button" onClick={() => zoomout()}> Zoom Out</button>*/}
                {/*</div>*/}
                <div className="main dragscroll">
                    <img id="map" style={{maxWidth: '100%'}}
                         src={url}/>
                </div>
            </a>;
        case("jpg"):
            return <a href={url} download>
                {/*<div id="navbar">*/}
                {/*<button type="button" onClick={() => zoomin()}> Zoom In</button>*/}
                {/*<button type="button" onClick={() => zoomout()}> Zoom Out</button>*/}
                {/*</div>*/}
                <div className="main dragscroll">
                    <img id="map" style={{maxWidth: '100%'}}
                         src={url}/>
                </div>
            </a>;
        case ("png"):
            return <a href={url} download>
                {/*<div id="navbar">*/}
                {/*<button type="button" onClick={() => zoomin()}> Zoom In</button>*/}
                {/*<button type="button" onClick={() => zoomout()}> Zoom Out</button>*/}
                {/*</div>*/}
                <div className="main dragscroll">
                    <img id="map" style={{maxWidth: '100%'}}
                         src={url}/>
                </div>
            </a>;
        default:
            return <div className="centerDiv"
                        style={{height: '300px', backgroundColor: '#eaeaea', padding: '10px 60px'}}><a
                href={url}><Button block
                                   size="lg"
                                   color="success">
                Open Report
            </Button></a></div>
    }
}

function zoomin() {
    var myImg = document.getElementById("map");
    var currWidth = myImg.clientWidth;
    if (currWidth === 2500) return false;
    else {
        myImg.style.width = (currWidth + 100) + "px";
    }
}

function zoomout() {
    var myImg = document.getElementById("map");
    var currWidth = myImg.clientWidth;
    if (currWidth === 100) return false;
    else {
        myImg.style.width = (currWidth - 100) + "px";
    }
}


// WEBPACK FOOTER //
// ./src/components/Reports/oneReport.jsx